import { render, staticRenderFns } from "./LeaveRecord.vue?vue&type=template&id=64bc128c"
import script from "./LeaveRecord.vue?vue&type=script&lang=js"
export * from "./LeaveRecord.vue?vue&type=script&lang=js"
import style0 from "./LeaveRecord.vue?vue&type=style&index=0&id=64bc128c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports